import React, { useEffect, useState, Fragment } from 'react';
import Icon from '../../../shared/components/atoms/Icon/Icon';
import ArticleService from '../../../shared/services/articles';
import SessionService from '../../../shared/services/session';
import CardArticleItem from '../../../shared/components/molecules/cardArticleItem/cardArticleItem';
import TagsArticles from '../tagsArticles/tagsArticles';
import useSessionState from '../../../shared/hooks/useSessionState';
import LeafletCard from '../../../shared/components/molecules/leaflet-card/leaflet-card';
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import './articlesListSection.scss';

const ArticlesListSection = props => {

  const articleBase = 12;
  const [tagActive, setTagActive] = useState([]);
  const [articles, setArticles] = useState(props.articulos);
  const [numArticles, setnumArticles] = useState(articleBase);
  const [isDropdownOpened, setDropdown] = useState(false);
  const [listLikes, setlistLikes] = useState(null)
  const [localLikes, setlocalLikes] = useState([])
  const { isLoggedUser } = useSessionState();
  const { homeLink } = useHomeLinkMode();

  useEffect(() => {
    handleLoadLikes();
    setlocalLikes(localStorage.getItem('LOCAL_LIKES_ARTICLES') !== null ? JSON.parse(localStorage.getItem('LOCAL_LIKES_ARTICLES')) : [])
  }, [])

  const isLiked = (idProduct, list) => {
    let i
    for (i = 0; i < list.length; i++) {
      if (list[i] === idProduct) {
        return true;
      }
    }

    return false;
  }

  const getArticleAtr = (idProduct, list) => {
    let i
    for (i = 0; i < list.length; i++) {
      if (list[i].idCMS === idProduct) {
        return list[i];
      }
    }

    return false;
  }

  const handleLoadLikes = () => {
    if (!(localStorage.getItem('tokenData') || sessionStorage.getItem('tokenData'))) { //Verify if is user logged
      ArticleService.getAnomLikes().then(res => {
        setlistLikes(res.data)
      }).catch(e => console.log(e))
    } else {
      localStorage.removeItem('LOCAL_LIKES_ARTICLES');

      const config = {
        headers: {
          Authorization: SessionService.getIdTokenData(),
        },
      }

      ArticleService.getAuthLikes(config).then(res => {
        for (let index = 0; index < res.data.length; index++) {
          if (res.data[index].userLike) {
            if (localStorage.getItem('LOCAL_LIKES_ARTICLES') !== null) {
              const copyLocalLikes = JSON.parse(localStorage.getItem("LOCAL_LIKES_ARTICLES"))
              localStorage.setItem('LOCAL_LIKES_ARTICLES', JSON.stringify(copyLocalLikes.concat(res.data[index].idCMS)))
              setlocalLikes(copyLocalLikes.concat(res.data[index].idCMS))
            } else {
              localStorage.setItem('LOCAL_LIKES_ARTICLES', JSON.stringify([res.data[index].idCMS]))
              setlocalLikes([res.data[index].idCMS])
            }

          }
        }
        setlistLikes(res.data)
      }).catch(e => console.log(e))

    }
  }

  const filterTag = () => {
    setnumArticles(articleBase)
    const infoFilterAux = []
    let vacio = true
    for (let i = 0; i < tagActive.length; i++) {
      if (tagActive[i] !== undefined) {
        vacio = false;
        Array.prototype.push.apply(infoFilterAux, filterForTag(props.articulos, tagActive[i]));
      }
    }
    if (!vacio) {
      setArticles(infoFilterAux)
    } else {
      setArticles(props.articulos)
    }

  }
  const filterForTag = (infoFilterAux, tagFilter) => {
    return infoFilterAux.filter((info) => info.etiquetas.find(({ nombreDeEtiqueta }) => nombreDeEtiqueta === tagFilter))
  }
  return (
    <section className={`${props.isCurved ? 'f-articles-section f-articles-section--curved' : 'f-articles-section'}`}>
      <div className="f-articles-section-container">
        {!props.isMobile && <TagsArticles tags={props.tags}
          tagActive={tagActive}
          setTagActive={setTagActive}
          filterTag={filterTag}
          slug={props.currentSlug} />}
        {props.isMobile &&
          <div className={`${isDropdownOpened ? 'f-dropdown-container-opened' : 'f-dropdown-container-closed'}`}>
            <div className={`f-dropdown-bar ${isDropdownOpened && 'f-dropdown-bar-opened'}`} onClick={() => setDropdown(!isDropdownOpened)}>
              <p className="f-dropdown-title" >CATEGORÍAS</p>
              <Icon icon="icon-chevron-down lonchmara" size="0-7" tagtype="i" />
            </div>
            {isDropdownOpened && <TagsArticles tags={props.tags}
              tagActive={tagActive}
              setTagActive={setTagActive}
              filterTag={filterTag}
              slug={props.currentSlug} />}
          </div>}
        <div className="f-articles-container">
          {props.tienePautas && !props.isMobile && (
            <a className="f-articles-container-pauta" href={homeLink + props.pauta[0].redireccion}>
              <img src={props.pauta[0].imagenes[0].fluid.src} alt="" />
            </a>
          )}
          {articles.map((articulo, index) => {
            if (index === 0 && props.isMobile && props.tienePautas) {
              return (
                <Fragment key={index}>
                  <CardArticleItem
                    articulo={articulo}
                    key={index}
                    isMobile={props.isMobile}
                    idArticle={articulo.contentful_id}
                    likesInfo={listLikes !== null && getArticleAtr(articulo.contentful_id, listLikes)}
                    setlistLikes={setlistLikes}
                    setlocalLikes={setlocalLikes}
                    isLocalLiked={isLiked(articulo.contentful_id, localLikes)}
                  />
                  <a className="f-articles-container-pauta" href={homeLink + props.pauta[0].redireccion}>
                    <img src={props.pauta[0].imagenes[1].fluid.src} alt="" />
                  </a>
                </Fragment>
              )
            } else if (index < numArticles) {
              return <CardArticleItem
                articulo={articulo}
                key={index}
                isMobile={props.isMobile}
                idArticle={articulo.contentful_id}
                likesInfo={listLikes !== null && getArticleAtr(articulo.contentful_id, listLikes)}
                setlistLikes={setlistLikes}
                setlocalLikes={setlocalLikes}
                isLocalLiked={isLiked(articulo.contentful_id, localLikes)}
              />
            }
            return null
          }
          )
          }
        </div>
        <div className="f-articles-section-cargar">
          {articles.length > numArticles && <p onClick={() => setnumArticles(numArticles + articleBase)}>CARGAR MÁS ARTÍCULOS</p>}
        </div>
        {
          isLoggedUser ? null :
            <LeafletCard isMobile={props.isMobile} leafletContent={props.leafletContent} />
        }
      </div>
    </section>
  )
}

export default ArticlesListSection;
